import React, { useEffect, useState } from 'react';

const modernFooterStyles = `
  .footer-modern-section {
    width: 100%;
    background: linear-gradient(90deg, #6366f1 0%, #818cf8 100%);
    color: #fff;
    padding: 0.7rem 0 0.3rem 0;
    font-family: 'Inter', 'Segoe UI', Arial, sans-serif;
    font-size: 1.08rem;
    font-weight: 500;
    letter-spacing: 0.02em;
    box-shadow: 0 -2px 16px 0 rgba(99,102,241,0.08);
    margin-top: 2rem;
    border-top-left-radius: 18px;
    border-top-right-radius: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 60px;
  }
  .footer-modern-content {
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.2rem;
  }
  .footer-modern-link {
    color: #ffe066;
    text-decoration: none;
    font-weight: 600;
    margin-left: 0.3em;
    transition: color 0.18s;
  }
  .footer-modern-link:hover {
    color: #fff;
    text-decoration: underline;
  }
  @media (max-width: 600px) {
    .footer-modern-section {
      font-size: 0.97rem;
      padding: 0.5rem 0 0.2rem 0;
      min-height: 44px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
    .footer-modern-content {
      max-width: 99vw;
      padding: 0 0.2rem;
    }
  }
`;

export default function Footer() {
  const [currentYear, setCurrentYear] = useState();
  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, []);
  return (
    <footer className="footer-modern-section">
      <style>{modernFooterStyles}</style>
      <div className="footer-modern-content">
        <span>
          &copy; <span id="displayYear">{currentYear}</span> All Rights Reserved By
          <a className="footer-modern-link" href="https://idntica.com/" target="_blank" rel="noopener noreferrer">idntica.com</a>
        </span>
      </div>
    </footer>
  );
}
